import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { RefreshCw } from 'lucide-react';
import { Button } from '../ui/button';
import { getToken } from '../../services/tokenService';
import { useIsSuperAdmin } from '../DocumentSections/RegenererRecuButton';

const API = process.env.REACT_APP_BACKEND_URL;

export const RegenererTousRecus = ({ onDone }) => {
  const [job, setJob] = useState(null);
  const timer = useRef(null);
  const superAdmin = useIsSuperAdmin();
  useEffect(() => () => clearInterval(timer.current), []);
  if (!superAdmin) return null;
  const headers = { Authorization: `Bearer ${getToken()}` };
  const suivre = (id) => {
    timer.current = setInterval(async () => {
      try {
        const { data } = await axios.get(`${API}/api/recus/regeneration/tous/${id}`, { headers });
        setJob(data);
        if (data.statut !== 'en_cours') {
          clearInterval(timer.current);
          toast.success(`${data.recus} reçu(s) régénéré(s)${data.erreurs.length ? `, ${data.erreurs.length} en échec` : ''}`);
          onDone && onDone();
        }
      } catch { clearInterval(timer.current); }
    }, 3000);
  };
  const lancer = async () => {
    if (!window.confirm('Régénérer tous les reçus déjà émis avec le bon dispositif, le chantier et la période ?\nLes numéros restent identiques et les membres ne sont pas prévenus.')) return;
    try {
      const { data } = await axios.post(`${API}/api/recus/regeneration/tous`, {}, { headers });
      setJob(data);
      suivre(data.id);
    } catch (err) { toast.error(err.response?.data?.detail || 'Impossible de lancer la régénération'); }
  };
  const enCours = job?.statut === 'en_cours';
  return (
    <Button variant="ghost" onClick={lancer} disabled={enCours} className="text-white hover:bg-white/20" data-testid="btn-regenerer-tous-recus">
      <RefreshCw className={`h-4 w-4 mr-2 ${enCours ? 'animate-spin' : ''}`} />
      {enCours ? `Régénération ${job.traites}/${job.total}` : 'Régénérer tous les reçus'}
    </Button>
  );
};
